<template>
  <nav class="header" role="navigation" aria-label="main navigation">
    <div class="logo-align">
      <router-link to="/" class="float-left" aria-label="Go Home">
        <img
          src="@/assets/images/site/frontendsource.svg"
          alt="frontendsource logo"
        />
        <!-- <img
          v-if="$state.navbar.active === vue | all"
          src="@/assets/images/site/frontendsource_vue.svg"
        />
        <img
          v-if="$state.navbar.active === react | all"
          src="@/assets/images/site/frontendsource_react.svg"
        />
                <img
          v-if="$state.navbar.active === jekyll | all"
          src="@/assets/images/site/frontendsource_jekyll.svg"
        />
                <img
          v-if="$state.navbar.active === gatsby | all"
          src="@/assets/images/site/frontendsource_gatsby.svg"
        />-->
      </router-link>
      <router-link to="/submit">
        <button
          v-show="$route.path !== '/submit'"
          class="submit btn btn-primary btn-medium float-right"
        >
          Submit Resource
        </button>
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.header {
  padding: 8px 20px 6px;
  background: $white;
  box-shadow: $box-shadow-nav;
}

.logo-align {
  text-align: left;
  img {
    width: $logo-width;
  }
}

.submit {
  margin-top: 2px;
}
</style>
